<template>
  <!--<transition name="fade" mode="out-in">-->
    <router-view :key="$route.fullPath"/>
  <!--</transition>-->
</template>

<script>
  export default {
    name: "FrontLayout"
  };
</script>

<style>
  .fade-leave-active {
    transition-duration: 0.1s;
  }

  .fade-enter-active {
    transition-duration: 0.1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/FrontLayout.vue